module.exports = __webpack_public_path__ + "static/media/grubhero-screenshot-5.b30b5a1a.png";